// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import colors from "vuetify/lib/util/colors";
import { aliases, mdi } from "vuetify/iconsets/mdi";

// Vuetify

export default {
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    styles: { configFile: "src/settings.scss" },
    themes: {
      light: {
        // dark: true,
        colors: {
          primary: colors.blue.darken2, // #E53935
          secondary: colors.teal.lighten2, // #FFCDD2
          accent: colors.blueGrey.darken4,
        },
      },
    },
  },
  ssr: true,
};
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
